import { render, staticRenderFns } from "./WaitResults.vue?vue&type=template&id=6aeb1a7a&scoped=true&"
import script from "./WaitResults.vue?vue&type=script&lang=js&"
export * from "./WaitResults.vue?vue&type=script&lang=js&"
import style0 from "./WaitResults.vue?vue&type=style&index=0&id=6aeb1a7a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aeb1a7a",
  null
  
)

export default component.exports